import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=c73cad08&scoped=true&"
import script from "./Values.vue?vue&type=script&lang=js&"
export * from "./Values.vue?vue&type=script&lang=js&"
import style0 from "./Values.vue?vue&type=style&index=0&id=c73cad08&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73cad08",
  null
  
)

export default component.exports